import styled from 'styled-components';


export const MessageContent = styled.div`
  height: 100px;
  width: 100px
`;